module.exports = __webpack_public_path__ + "img/default_bg.cec9b984.svg";